import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=07aef56e"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports